import { faTrashCan } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Pet from '@spike/pet-model';
import clsx from 'clsx';
import PetCard from 'components/UI/PetCard';
import { FunctionComponent } from 'react';

export interface PetInfoProps {
    pet: Pet;
    onDelete?: () => void;
    onShowPetCard?: () => void;
    actions?: React.ReactNode;
    className?: string;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            display: 'flex',
            position: 'relative',
            alignItems: 'flex-start',
            alignSelf: 'stretch',
            boxSizing: 'border-box',
            minWidth: 0
        },
        petDescriptionWithActions: {
            marginTop: 12
        },
        actions: {
            position: 'absolute',
            right: 0,
            top: 0,
            zIndex: 1
        },
        deleteButtonContainer: {
            position: 'absolute',
            cursor: 'pointer',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            top: 15,
            right: 20,
            height: 38,
            width: 38,
            borderRadius: 38,
            background: '#F1F1F1'
        }
    })
);

export const PetInfo: FunctionComponent<PetInfoProps> = props => {
    const classes = useStyles();

    const deleteButton = (
        <Box
            className={classes.deleteButtonContainer}
            onClick={props.onDelete}
        >
            <FontAwesomeIcon
                icon={faTrashCan}
                fontSize={16}
            />
        </Box>
    );

    return (
        <Box className={clsx(classes.container, props.className)}>
            {props.onDelete && deleteButton}
            <PetCard
                pet={props.pet}
                onShowPetCard={props.onShowPetCard}
                petDescriptionClassName={props.actions ? classes.petDescriptionWithActions : undefined}
            />
            {props.actions && <div className={classes.actions}>{props.actions}</div>}
        </Box>
    );
};

export default PetInfo;
